import React from 'react';
import styled from 'styled-components';
import {
  Col, Flex, Image, Row,
} from 'antd';
import { colors, fonts } from '../assets/constStyles';
import { ButtonMainRed } from './button/ButtonMainRed';
import { paths } from '../consts';

// const ImageStyled = styled(Image)`
//   width: 100%;
//   display: block;
//   object-fit: cover;
//   z-index: 0;
//   background-size: cover;
//
//   @media (max-width: 768px) {
//   }
// `;

// const DivContentStyled = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   z-index: 2;
//   padding: 90px;
// `;

const IconStyled = styled(Image)`
  width: 300px;
  height: 70px;
  object-fit: cover;
`;

const H3Styled = styled.h3`
  color: ${colors.colorTextWhite};
  text-transform: uppercase;
  font-weight: 700;
  font-size: 30px;
  font-family: ${fonts.font2};
`;

const PStyled = styled.p`
  color: ${colors.colorTextWhite};
  font-size: 18px;
  flex-grow: 1;
  font-family: ${fonts.font2};
`;

const DivStyled = styled.div`
  padding: 90px;
  position: relative;
  z-index: 300;

     @media (max-width: 768px) {
     padding: 20px;
     }
`;

const DivContainerStyled = styled.div`
  position: relative;
  background-image: url('../img/1-telus-high.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  @media (max-width: 768px) {
    background-position: 25%;
  }
  
  
   &::after {
     content: '';
     position: absolute;
     inset: 0;
     background: rgba(0, 0, 0, 0.8);
     z-index: 1;
     pointer-events: none;
   }
`;

export const BlockGis: React.FC = () => (
    <DivContainerStyled>
        <DivStyled>
            <Row gutter={[24, 24]} align="stretch">
                <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Flex vertical align={'flex-end'} justify={'space-between'}
                          style={{ padding: '0px 12px', height: '100%' }}>
                        <IconStyled src={'../img/gis.svg'} preview={false}/>
                    </Flex>
                </Col>
                <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
                    <Flex vertical align={'flex-start'} justify={'space-between'}
                          style={{ padding: '0px 12px', height: '100%' }}>
                        <H3Styled>GUARANTEE YOUR WOODWORK</H3Styled>
                        <Flex vertical gap={10} style={{ marginTop: 20 }}>
                            <PStyled>With every job you take on – large and small – you know the risks. What you need is an assurance that what is specified is what gets built.</PStyled>
                            <PStyled>Through AWMAC’s Guarantee and Inspection Service (GIS), you’ll ensure that quality architectural woodwork is delivered on every project.</PStyled>
                            <PStyled>In the end, your customers get what they want – and you are recognized as an industry leader in front of the best customers.</PStyled>
                        </Flex>
                        <Flex justify={'flex-start'} style={{ marginTop: '50px' }}>
                            <ButtonMainRed text={'Learn About GIS'} route={paths.GIS}/>
                        </Flex>
                    </Flex>
                </Col>
            </Row>
        </DivStyled>
    </DivContainerStyled>
);
